module.exports = __webpack_public_path__ + "img/NukedTV-Web_37.f137480b.png";